import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { getHoursMinutesFromTime } from '@/shared/utils/dateHelper';
import messages from './FieldMessages';
import RenderProperty from './RenderProperty';
import { parseBoolean, parseDate } from './FieldChange';
const LABEL_BY_PROPERTY = {
    ScheduleName: messages.PlannedRegistrationSchedule,
    StartDate: messages.PlannedRegistrationStartDate,
    EndDate: messages.PlannedRegistrationEndDate,
    Day: messages.PlannedRegistrationDay,
    Month: messages.PlannedRegistrationMonth,
    ResourceName: messages.PlannedRegistrationResource,
    EmployeeId: messages.PlannedRegistrationUser,
    PriceGridName: messages.PlannedRegistrationPriceGrid,
    InForfait: messages.PlannedRegistrationInForfait,
    DurationMinutes: messages.PlannedRegistrationDuration,
    Quantity: messages.PlannedRegistrationQuantity,
    Remark: messages.PlannedRegistrationRemark,
    InvoiceStreamId: messages.PlannedRegistrationAssignment,
};
const PlannedRegistrationPropertyChange = ({ log, users, invoiceStreamNames }) => {
    var _a, _b;
    const intl = useIntl();
    const formatValue = (value) => {
        var _a, _b, _c;
        if (value === null || value === undefined || value === '')
            return '/';
        switch (log.property) {
            case 'DurationMinutes':
                return getHoursMinutesFromTime(Number(value));
            case 'Month':
                return moment.months(Number(value) - 1);
            case 'EmployeeId':
                return (_a = users === null || users === void 0 ? void 0 : users[value]) !== null && _a !== void 0 ? _a : '/';
            case 'InvoiceStreamId':
                return (_b = invoiceStreamNames === null || invoiceStreamNames === void 0 ? void 0 : invoiceStreamNames[value]) !== null && _b !== void 0 ? _b : '/';
            case 'InForfait': {
                const inForfait = parseBoolean(value);
                if (inForfait === null)
                    return '/';
                return intl.formatMessage(inForfait ? messages.Yes : messages.No);
            }
            case 'StartDate':
            case 'EndDate':
                return (_c = parseDate(value)) !== null && _c !== void 0 ? _c : value;
            default:
                return value;
        }
    };
    const label = LABEL_BY_PROPERTY[log.property];
    return (_jsxs("span", { children: [intl.formatMessage(messages.ChangedField, {
                property: label ? intl.formatMessage(label) : RenderProperty({ intl, log }),
                originalValue: formatValue((_a = log.oldValue) === null || _a === void 0 ? void 0 : _a.Value),
                currentValue: formatValue((_b = log.newValue) === null || _b === void 0 ? void 0 : _b.Value),
            }), log.displayValue
                ? intl.formatMessage(messages.PlannedRegistrationWithDisplayValueProperty, {
                    name: log.displayValue,
                    b: value => _jsx("b", { children: value }),
                })
                : intl.formatMessage(messages.PlannedRegistrationProperty)] }));
};
export default PlannedRegistrationPropertyChange;
